import { useReadLegalEntityPreferencesQuery } from "@digits-graphql/frontend/graphql-bearer"
import useSession from "@digits-shared/hooks/useSession"
import type FrontendSession from "src/frontend/session"

export const useShowAgingReports = () => {
  const { currentLegalEntityId } = useSession<FrontendSession>()
  return useReadLegalEntityPreferencesQuery({
    variables: {
      legalEntityId: currentLegalEntityId,
    },
  }).data?.readLegalEntityPreferences?.showAgingReports
}
